import React from "react";
import Question from '../components/Question'
import { Form } from 'react-bootstrap'

import QuoteStepBase, { mapInsuranceStepProps, getInsuranceStepMapDispatch } from '../components/QuoteStepBase'
import ButtonContinue from "../components/ButtonContinue";
import { IQuoteStepState, ICurrentInsuranceStepProps } from "../components/interfaces";
import QuoteStep from "./QuoteStepLayout";
import { ValidatableForm } from "../components/ValidatableForm";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import { PATHS, QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";
import { IAppState } from "../state/interfaces";
import InsuranceApiClient from "../classes/InsuranceApiClient";
import Utilities from "../classes/Utilities";

interface IState extends IQuoteStepState {
    currentInsuranceCompany : string,
    currentInsuranceCompanyPeriod : string,
    currentInsuranceCompanyMonths : string,
    currentBiLimits : string,
    visibleCurrentInsuranceCompanyMonths: boolean,
    insuranceCompanies: Array<IInsuranceCompany>,
    loadingCompanies : boolean;
}

interface IInsuranceCompany {
    id: string,
    name: string;
}

interface IInsuranceHistoryProps extends ICurrentInsuranceStepProps {
    currentInsuranceCompanyLabel : string,
    currentInsuranceCompanyPeriodLabel : string,
    currentInsuranceCompanyMonthsLabel : string,
    currentBiLimitsLabel: string;
}

class InsuranceHistory extends QuoteStepBase<IInsuranceHistoryProps, IState> {
    constructor(props: IInsuranceHistoryProps) {
        super(props);

        this.next = this.next.bind(this);

        this.state = {
            currentInsuranceCompany : "",
            currentInsuranceCompanyPeriod : "",
            currentInsuranceCompanyMonths : "",
            currentBiLimits : "",
            visibleCurrentInsuranceCompanyMonths: false,
            loadingCompanies: false,
            insuranceCompanies: [{ id: "", name: "Select" }],
            updatingStore: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();

        this.setState({ loadingCompanies: true },
            () => {
                new InsuranceApiClient().getInsuranceCompanies()
                    .then((response) => {
                        const items = new Array();
                        items.push({ id: "", name: "Select" });
                        for (let i = 0; i < response.data.length; i++) {
                            items.push({ id: response.data[i].id.toString(), name: response.data[i].name});
                        }
                        this.setState({ ...this.state, loadingCompanies: false, insuranceCompanies: items });
                    });
            });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const currentInsurance = nextProps.currentInsurance;
            nextProps.meta.propsSource = "";

            if (!currentInsurance) return prevState;

            return {
                ...prevState,
                currentInsuranceCompany: currentInsurance.currentInsuranceCompany,
                currentInsuranceCompanyPeriod: currentInsurance.currentInsuranceCompanyPeriod,
                currentInsuranceCompanyMonths: currentInsurance.currentInsuranceCompanyMonths,
                currentBiLimits: currentInsurance.currentBiLimits
            };
        }

        return prevState;
    }

    next(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {
            const updatedCurrentInsurance = {
                ...this.props.currentInsurance,
                currentInsuranceCompany: this.state.currentInsuranceCompany,
                currentInsuranceCompanyPeriod: this.state.currentInsuranceCompanyPeriod,
                currentInsuranceCompanyMonths: this.state.currentInsuranceCompanyMonths,
                currentBiLimits: this.state.currentBiLimits
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, currentInsurance: updatedCurrentInsurance })
                .then(() => this.props.history.push(PATHS.NEW_POLICY),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    callbackFunctionCompanyPeriod(childData: string) {
        switch (childData) {
            case QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.LESS_ONE_YEAR:
            this.setState({
                currentInsuranceCompanyPeriod: childData,
                visibleCurrentInsuranceCompanyMonths: true
            });
            break;
        default :
            this.setState({
                currentInsuranceCompanyPeriod: childData,
                visibleCurrentInsuranceCompanyMonths: false
            });
            break;
        }
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><h5>INSURANCE HISTORY</h5></div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <Form.Group>
                        <Form.Label>{this.props.currentInsuranceCompanyLabel}</Form.Label>
                        <Form.Control as="select"
                            value={this.state.currentInsuranceCompany}
                            disabled={this.state.loadingCompanies}
                            onChange={(e) => { this.setStateValue(e.target.value, "currentInsuranceCompany") }}>
                            {this.state.insuranceCompanies.map(c => <option key={Utilities.uniqueId()} value={c.id}>{c.name}</option>)}
                        </Form.Control>
                        {null != this.state.errors && validationUtils.hasValidationErrorFor(this.state.errors, "currentInsuranceCompany")
                            ? <Form.Control.Feedback type="invalid">
                                {validationUtils.getValidationErrorFor(this.state.errors, "currentInsuranceCompany")}
                            </Form.Control.Feedback>
                            : null
                        }
                    </Form.Group>

                    <Question
                        name="currentInsuranceCompanyPeriod"
                        selectedValue={this.state.currentInsuranceCompanyPeriod}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "currentInsuranceCompanyPeriod")}
                        selected={(v) => this.callbackFunctionCompanyPeriod(v)}
                        showItems={6}
                        items={[
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.LESS_ONE_YEAR,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.ONE_YEAR,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.TWO_YEARS,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.THREE_YEARS,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.FOUR_YEARS,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.FIVE_YEARS,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.SIX_TEN_YEARS,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.ELEVEN_FIFTEEN_YEARS,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.SIXTEEN_TWENTY_YEARS,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.MORE_TWENTY_YEARS
                        ]}
                        lable={this.props.currentInsuranceCompanyPeriodLabel} />

                    <Question
                        name="currentInsuranceCompanyMonths"
                        selected={(v) => this.setStateValue(v, "currentInsuranceCompanyMonths")}
                        selectedValue={this.state.currentInsuranceCompanyMonths}
                        style={{ display: this.state.visibleCurrentInsuranceCompanyMonths ? '' : 'none' }}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "currentInsuranceCompanyMonths")}
                        items={[
                            "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"
                        ]}
                        lable={this.props.currentInsuranceCompanyMonthsLabel} />

                    <Question
                        name="currentBiLimits"
                        selectedValue={this.state.currentBiLimits}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "currentBiLimits")}
                        selected={(v) => this.setStateValue(v, "currentBiLimits")}
                        items={[
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.BI_LIMITS.MINIMUM,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.BI_LIMITS.LESS_THAN_50_100,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.BI_LIMITS.LESS_THAN_100_300,
                            QUOTE_QUESTIONS.INSURANCE_HISTORY.BI_LIMITS.GREATER_THAN_100_300
                        ]}
                        lable={this.props.currentBiLimitsLabel} />

                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    var props = mapInsuranceStepProps(state);
    return {
        ...props,
        currentInsuranceCompanyLabel: state.currentInsurance.hasInsurance === QUOTE_QUESTIONS.YES_NO.YES
            ? "Who is your current insurance company?"
            : "Who was your most recent insurance company?",
        currentInsuranceCompanyPeriodLabel: state.currentInsurance.hasInsurance === QUOTE_QUESTIONS.YES_NO.YES
            ? "How long have you been with your current insurance company?"
            : "How long were you with your most recent insurance company?",
        currentInsuranceCompanyMonthsLabel: state.currentInsurance.hasInsurance === QUOTE_QUESTIONS.YES_NO.YES
            ? "How many months have you been with your current insurance company?"
            : "How many months were you with your most recent insurance company?",
        currentBiLimitsLabel: state.currentInsurance.hasInsurance === QUOTE_QUESTIONS.YES_NO.YES
            ? "What are your current Bodily Injury (BI) limits?"
            : "What were your most recent Bodily Injury (BI) limits?",
        insuranceCompanies : []
    };
};

export default connect(mapProps, getInsuranceStepMapDispatch(QUOTE_STEPS.INSURANCE_HISTORY))(InsuranceHistory);
